import { render, staticRenderFns } from "./userInvigilationDetail.vue?vue&type=template&id=6fbb446e&scoped=true"
import script from "./userInvigilationDetail.vue?vue&type=script&lang=js"
export * from "./userInvigilationDetail.vue?vue&type=script&lang=js"
import style0 from "./userInvigilationDetail.vue?vue&type=style&index=0&id=6fbb446e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb446e",
  null
  
)

export default component.exports